import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const TagIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <path
        d="M6.00029 10.6667L5.45029 12.85C5.41696 12.9944 5.34474 13.1111 5.23362 13.2C5.12251 13.2889 4.98918 13.3333 4.83362 13.3333C4.62251 13.3333 4.45029 13.25 4.31696 13.0833C4.18362 12.9167 4.14474 12.7333 4.20029 12.5333L4.66696 10.6667H2.85029C2.62807 10.6667 2.45029 10.5805 2.31696 10.4083C2.18362 10.2361 2.14474 10.0444 2.20029 9.83332C2.23362 9.67777 2.3114 9.55554 2.43362 9.46666C2.55585 9.37777 2.69474 9.33332 2.85029 9.33332H5.00029L5.66696 6.66666H3.85029C3.62807 6.66666 3.45029 6.58055 3.31696 6.40832C3.18362 6.2361 3.14474 6.04443 3.20029 5.83332C3.23362 5.67777 3.3114 5.55555 3.43362 5.46666C3.55585 5.37777 3.69474 5.33332 3.85029 5.33332H6.00029L6.55029 3.14999C6.58362 3.00555 6.65585 2.88888 6.76696 2.79999C6.87807 2.7111 7.0114 2.66666 7.16696 2.66666C7.37807 2.66666 7.55029 2.74999 7.68362 2.91666C7.81696 3.08332 7.85585 3.26666 7.80029 3.46666L7.33362 5.33332H10.0003L10.5503 3.14999C10.5836 3.00555 10.6558 2.88888 10.767 2.79999C10.8781 2.7111 11.0114 2.66666 11.167 2.66666C11.3781 2.66666 11.5503 2.74999 11.6836 2.91666C11.817 3.08332 11.8558 3.26666 11.8003 3.46666L11.3336 5.33332H13.1503C13.3725 5.33332 13.5503 5.41943 13.6836 5.59166C13.817 5.76388 13.8558 5.95555 13.8003 6.16666C13.767 6.32221 13.6892 6.44443 13.567 6.53332C13.4447 6.62221 13.3058 6.66666 13.1503 6.66666H11.0003L10.3336 9.33332H12.1503C12.3725 9.33332 12.5503 9.41943 12.6836 9.59166C12.817 9.76388 12.8558 9.95554 12.8003 10.1667C12.767 10.3222 12.6892 10.4444 12.567 10.5333C12.4447 10.6222 12.3058 10.6667 12.1503 10.6667H10.0003L9.45029 12.85C9.41696 12.9944 9.34474 13.1111 9.23362 13.2C9.12251 13.2889 8.98918 13.3333 8.83362 13.3333C8.62251 13.3333 8.45029 13.25 8.31696 13.0833C8.18362 12.9167 8.14474 12.7333 8.20029 12.5333L8.66696 10.6667H6.00029ZM6.33362 9.33332H9.00029L9.66696 6.66666H7.00029L6.33362 9.33332Z"
        fill={color}
      />
    </svg>
  );
};

export default TagIcon;
